export default "__VITE_ASSET__sZuJr3Xc__"